import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagRu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1262_13469)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2539 16.1733C23.7363 14.8734 24.0003 13.4673 24.0003 11.9995C24.0003 10.5316 23.7363 9.12555 23.2539 7.82556H0.746665C0.264322 9.12555 0.000274658 10.5316 0.000274658 11.9995C0.000274658 13.4673 0.264322 14.8734 0.746665 16.1733L12.0003 17.2168L23.2539 16.1733Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0003 23.9995C17.1599 23.9995 21.5584 20.743 23.254 16.1734H0.746735C2.44225 20.743 6.84076 23.9995 12.0003 23.9995Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1262_13469",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFlagRu;
